// This directive allows you to create a tooltip that can display any Angular component.
// It uses Angular's CDK Overlay to create a flexible connected overlay that can be positioned relative to the host element.
import {
    Directive,
    Input,
    HostListener,
    ViewContainerRef,
    Type,
    ComponentRef,
    Injector
  } from '@angular/core';
  import { Overlay, OverlayRef } from '@angular/cdk/overlay';
  import { ComponentPortal } from '@angular/cdk/portal';
  import { TooltipContainerComponent } from '../components/dynamic-portal-tooltip/tooltip-wrapper/tooltip-container.component'; // path here
  
  @Directive({
    selector: '[appComponentTooltip]'
  })
  export class ComponentTooltipDirective {
    @Input('appComponentTooltip') tooltipComponent!: Type<any>;
    @Input() tooltipInputs: { [key: string]: any } = {};
    @Input() tooltipDelay = 300;
  
    private overlayRef: OverlayRef | null = null;
    private containerRef: ComponentRef<TooltipContainerComponent> | null = null;
    private showTimeoutId: any;
  
    constructor(
      private overlay: Overlay,
      private viewContainerRef: ViewContainerRef,
      private injector: Injector
    ) {}
  
    @HostListener('mouseenter')
    onMouseEnter() {
      this.showTimeoutId = setTimeout(() => {
        this.showTooltip();
      }, this.tooltipDelay);
    }
  
    @HostListener('mouseleave')
    onMouseLeave() {
      clearTimeout(this.showTimeoutId);
      this.hideTooltip();
    }
  
    private showTooltip() {
      if (this.overlayRef) return;
  
      const positionStrategy = this.overlay.position()
        .flexibleConnectedTo(this.viewContainerRef.element)
        .withPositions([
          {
            originX: 'center',
            originY: 'top',
            overlayX: 'center',
            overlayY: 'bottom',
            offsetY: -20 
          }
        ]);
  
      this.overlayRef = this.overlay.create({
        positionStrategy,
        scrollStrategy: this.overlay.scrollStrategies.reposition(),
        panelClass: 'pure-tooltip-panel'
      });
  
      const containerPortal = new ComponentPortal(TooltipContainerComponent);
      this.containerRef = this.overlayRef.attach(containerPortal);
  
      if (this.containerRef.instance.viewContainerRef) {
        const componentRef = this.containerRef.instance.viewContainerRef.createComponent(this.tooltipComponent);

        if (this.tooltipInputs) {
          Object.keys(this.tooltipInputs).forEach(key => {
            componentRef.instance[key] = this.tooltipInputs[key];
          });

        }
      }
    }
  
    private hideTooltip() {
      if (this.overlayRef) {
        this.overlayRef.dispose();
        this.overlayRef = null;
        this.containerRef = null;
      }
    }
  }
  